import type { ReactNode } from 'react';
import { Card, type CardTone } from '@src/components/Card/Card';
import { classes } from '@src/components/layout/space';
import { testIdFor } from '@src/components/testId';
import { Panel, type PanelProps } from '@src/components/Panel/Panel';
import './PreviewCard.css';

export interface PreviewCardProps {
  title: string;
  children?: ReactNode;
  /** Paints the step disc and the title. The card itself stays white. */
  tone?: CardTone;
  step?: ReactNode;
  edges?: PanelProps['edges'] | false;
  testId?: string;
}

/** A festive step card with vector edges. */
export function PreviewCard({
  title,
  children,
  tone = 'support',
  step,
  testId,
  edges,
}: PreviewCardProps) {
  return (
    <Panel
      as="article"
      padding="none"
      elevated
      edges={
        edges === false
          ? undefined
          : (edges ?? { pieces: tone === 'accent' ? 10 : tone === 'info' ? 11 : 9 })
      }
      className={classes('preview-card', `preview-card--${tone}`)}
      testId={testId}
    >
      <Card
        surface="plain"
        tone={tone}
        step={step}
        title={title}
        className="preview-card__copy"
        testId={testIdFor(testId, 'copy')}
      >
        {children}
      </Card>
    </Panel>
  );
}
